document.addEventListener('DOMContentLoaded', function(){
  const storage = {};
  const loadMoreButton = document.querySelector('.main-blog__button');
  const articlesWrapper = document.querySelector('.blog-articles');
  storage['default'] = [...articlesWrapper.querySelectorAll('.blog-articles__article')];
  const debouncedInput = delayExecution(getSearchResults, 500);
  function delayExecution(func, delay) {
    let timerId;
  
    return function(...args) {
        const context = this;
        
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
  }

  document.querySelector(".search-blog__input").addEventListener("input", function(event) {
      debouncedInput(event.target.value);
  });


  function getSearchResults(inputValue) {
    let searchTerm = prepareSearchTerm(inputValue);
  
    if (searchTerm === '') {
      renderDefaultResults();
      return;
    }
  
    const key = generateStorageKey(searchTerm);
    if (storage[key]) {
      renderMarkup(storage[key]);
      return;
    }
  
    fetchResults(searchTerm);
  }
  
  function prepareSearchTerm(inputValue) {
    let searchTerm = inputValue.trim();
  
    if (window.location.pathname.includes('tagged')) {
      const tag = getTagFromPath();
      searchTerm = searchTerm === '' ? `* tag:${tag}` : `${searchTerm}* tag:${tag}`;
    }
  
    return searchTerm;
  }
  
  function getTagFromPath() {
    const pathArray = window.location.pathname.split('/');
    return pathArray[pathArray.length - 1];
  }
  
  function generateStorageKey(searchTerm) {
    return searchTerm.replace(" ", "-").toLowerCase();
  }
  
  function renderDefaultResults() {
    renderMarkup(storage['default'], true);
  }
  
  function fetchResults(searchTerm) {
    fetch(`/search?q=${searchTerm}&resources[type]=article`)
      .then(response => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then(text => {
        const cardMarkups = parseArticleCardMarkups(text);
        const key = generateStorageKey(searchTerm);
        storage[key] = cardMarkups;
        if (loadMoreButton) {
          loadMoreButton.style.display = 'none';
        }
        renderMarkup(cardMarkups);
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });
  }
  
  function parseArticleCardMarkups(htmlText) {
    const articleCardWrappers = new DOMParser().parseFromString(htmlText, 'text/html').querySelectorAll('.custom-article');
    return Array.from(articleCardWrappers).map(wrapper => {
      return `<div class="blog-articles__article article scroll-trigger animate--slide-in">
                <div class="article-card-wrapper card-wrapper underline-links-hover">
                  ${wrapper.innerHTML}
                </div>
              </div>`;
    });
  }
  
  function renderMarkup(response, defaultMarkup) {
    if (defaultMarkup) {
      const wrapper = document.querySelector('.blog-articles');
      wrapper.innerHTML = '';
      loadMoreButton.style.display = 'block';
      response.forEach(item => wrapper.appendChild(item));
    } else {
      const htmlString = response.join('');
      document.querySelector('.blog-articles').innerHTML = htmlString;
    }
  }
  /*
  functions will be used in the future
  function toggleTagEventListeners(disabled) {
    const tags = document.querySelectorAll('.blog-categories__item');
    const action = disabled ? 'removeEventListener' : 'addEventListener';
    const handler = disabled ? tagClickHandler(event) : null;
  
    tags.forEach(tag => {
      tag[action]('click', handler);
    });
  }
  
  function tagClickHandler(event) {
      e.preventDefault();
      let categoryName = this.querySelector('.blog-category__name').innerHTML;
      let trimmedCategoryName = categoryName.replace(/\s+/g, '').toLowerCase();
  }*/
})